import { useSentinelPastViewportEdge } from "./use-sentinel-past-viewport-edge.ts";

export function useElementAboveViewportTop(
    sentinel: HTMLElement | null,
    options: { enabled?: boolean } = {},
): boolean {
    return useSentinelPastViewportEdge(sentinel, "top", options);
}
